<template>
	<v-container grid-list-md px-1 pb-0>
		<pdf v-if="!loading" v-bind:src="src"></pdf>
		<v-progress-circular
			:size="20"
			indeterminate
			color="black"
			v-if="loading"
		></v-progress-circular>
	</v-container>
</template>

<script>
import * as utils from '@/utils/utils';
import moment from 'moment';
import { _ } from 'vue-underscore';
import pdf from 'vue-pdf';
export default {
	name: 'InvoiceViewer',
	components: { pdf },
	created: function() {},
	data() {
		return {
			src: '',
			loading: false
		};
	},
	methods: {
		showPdf(reservationId, invoiceDate, isActive) {
			var self = this;
			this.loading = true;
			utils
				.setData(
					basePath +
						'api/reservations/' +
						(isActive ? 'getPreInvoice/' : 'getInvoice/') +
						reservationId,
					{ invoiceDate: invoiceDate }
				)
				.then(function(json) {
					self.loading = false;
					self.src =
						basePath +
						'api/downloader/downloadInvoice/' +
						json.data +
						'/' +
						reservationId;
				});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/subcomponents/InvoiceViewer.vue